export default __webpack_public_path__ + "static/media/logo.340b1373.svg";